let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("2dcZB")]).then(() => parcelRequire('kn29b'));